import { Icon, toIconsEnum } from 'components/Icons';

import { BroadcastEnum } from 'features/ippica/types';
import { LiveVideoStreaming } from 'features/live/liveVideoStreaming';
import { setIsOpenLoginModalValue } from 'features/modal/modalSlice';
import { useInternalSession } from 'hooks';
import { useAppDispatch } from 'lib/centralStore';
import React from 'react';
import { createRoot } from 'react-dom/client';
import styles from './IppicaBroadcastBox.module.scss';

export type IppicaBroadcastBoxProps = {
  url: string;
  name: string;
  type: BroadcastEnum;
  label?: string;
  logged?: boolean;
  containerClassName?: string;
  hasButtonOnIcon?: boolean;
};

export const IppicaBroadcastBox = ({
  type,
  label,
  name,
  logged,
  url,
  containerClassName,
  hasButtonOnIcon,
}: IppicaBroadcastBoxProps) => {
  const { isAuthenticated } = useInternalSession();
  const dispatch = useAppDispatch();

  const handleBroadCast = (type: BroadcastEnum, logged?: boolean, url?: string) => {
    switch (type) {
      case BroadcastEnum.RADIO:
        //url = `${process.env.NEXT_PUBLIC_ENDPOINT_RADIO}`;
        //openStreamingPopup(url!, 'width=316,height=200');
        let popupUrl = `${process.env.NEXT_PUBLIC_ENDPOINT_RADIO_POPUP}`;
        window.open(popupUrl, '_blank', `popup=yes,width=316,height=200`);
        break;
      case BroadcastEnum.TV:
        if (logged) {
          !isAuthenticated
            ? dispatch(setIsOpenLoginModalValue(true))
            : openStreamingPopup(url!, 'width=680,height=380');
        } else {
          openStreamingPopup(url!, 'width=660,height=360');
        }
        break;
      default:
        throw new Error(`error`);
    }
  };

  const openStreamingPopup = (url: string, size: string) => {
    if (typeof window !== 'undefined' && window instanceof Window) {
      const newWindow = window.open('', '_blank', `popup=yes,${size}`);

      const style = newWindow!.document.createElement('style');
      style.innerHTML = `html, body { margin: 0; padding: 0; }`;
      newWindow!.document.head.appendChild(style);

      newWindow!.document.title = `SNAI Live Streaming`;
      newWindow!.document.body.innerHTML = `<div id="root"></div>`;
      const root = createRoot(newWindow!.document.getElementById('root')!);
      root.render(
        <React.StrictMode>
          <LiveVideoStreaming
            audioIsMute={true}
            isFullScreen
            isHeightAuto
            urlStreaming={url}
            autoPlayActive
            availableControl={['nodownload', 'nofullscreen', 'noremoteplayback']}
            webkit-playsinline
          />
        </React.StrictMode>
      );
    }
  };

  if (hasButtonOnIcon) {
    return (
      <button type="button" className={styles.buttonContainer} onClick={() => handleBroadCast(type, logged, url)}>
        <Icon iconId={toIconsEnum(type)} className={styles.icon} color={'var(--color-on-bg-primary)'} />
        <span className={styles.labelStreaming}>VEDI STREAMING</span>
      </button>
    );
  }

  return (
    <div className={`${styles.container} ${containerClassName ? containerClassName : ''}`}>
      <Icon iconId={toIconsEnum(type)} className={styles.icon} color={'var(--color-on-bg-primary)'} />
      <p className={styles.textWrapper}>
        {label && <span className={styles.label}>{label}</span>}
        <span className={styles.name}>{name}</span>
      </p>
      <button type="button" className={styles.button} onClick={() => handleBroadCast(type, logged, url)}>
        {type === 'tv' ? 'Guarda' : 'Ascolta'}
      </button>
    </div>
  );
};
